import UiDetail from "./UiDetail";
import { EnumMiezzFormItemType, MiezzFormItem } from "@/models/MiezzForm";
import { EnumPipe } from "@/models/EnumPipe";
import { EnumCompanyType, EnumCompanyTypeOption } from "./EnumCompanyType";
import DtoDetailCompanyFollowUpRecord_CompanyFollowUpRecordMethod from "./DtoDetailCompanyFollowUpRecord_CompanyFollowUpRecordMethod";
import DtoDetailCompanyFollowUpRecord_CompanyFollowUpRecordInnerAccompanyPerson from "./DtoDetailCompanyFollowUpRecord_CompanyFollowUpRecordInnerAccompanyPerson";
import DtoDetailCompanyFollowUpRecord_CompanyFollowUpRecordContent from "./DtoDetailCompanyFollowUpRecord_CompanyFollowUpRecordContent";
import DtoDetailCompanyFollowUpRecord_CompanyFollowUpRecordFile from "./DtoDetailCompanyFollowUpRecord_CompanyFollowUpRecordFile";
import { EnumCompanyFollowUpRecordStatus, EnumCompanyFollowUpRecordStatusOption } from "./EnumCompanyFollowUpRecordStatus";
import UiGroup from "./UiGroup";

/**
 * 跟进记录详细
 * @description 自动生成的代码,请勿修改
 */
export default class DtoDetailCompanyFollowUpRecord extends UiDetail<string> {
    constructor() {
        //无参构造函数
        super()
        this.Methods = [];
        this.InnerAccompanyPeople = [];
        this.Contents = [];
        this.Files = [];
    }

    [proName: string]: any;
    /**
     * 公司类型
     */
    CompanyType?: EnumCompanyType;
    /**
     * 计划编号
     */
    Code?: string;
    /**
     * 客户企业Id
     */
    CustomerId?: string;
    /**
     * 客户企业
     */
    CustomerLabel?: string;
    /**
     * 跟进方式
     */
    Methods?: DtoDetailCompanyFollowUpRecord_CompanyFollowUpRecordMethod[];
    /**
     * 跟进人Id
     */
    FollowUpPersonId?: string;
    /**
     * 跟进人
     */
    FollowUpPersonLabel?: string;
    /**
     * 计划跟进时间
     */
    PlanFollowUpTime?: Date;
    /**
     * 计划完成时间
     */
    PlanCompleteTime?: Date;
    /**
     * 地点
     */
    AreaLabel?: string;
    /**
     * 详细地址
     */
    Address?: string;
    /**
     * 对方参与人员
     */
    CustomerJoinPerson?: string;
    /**
     * 内部陪同人员
     */
    InnerAccompanyPeople?: DtoDetailCompanyFollowUpRecord_CompanyFollowUpRecordInnerAccompanyPerson[];
    /**
     * 外部陪同人
     */
    OuterAccompanyPerson?: string;
    /**
     * 第三方参与人员
     */
    ThreeJoinPerson?: string;
    /**
     * 跟进内容
     */
    Contents?: DtoDetailCompanyFollowUpRecord_CompanyFollowUpRecordContent[];
    /**
     * 跟进内容描述
     */
    Description?: string;
    /**
     * 附件
     */
    Files?: DtoDetailCompanyFollowUpRecord_CompanyFollowUpRecordFile[];
    /**
     * 超链接文本
     */
    LinkLabel?: string;
    /**
     * 超链接
     */
    Link?: string;
    /**
     * 状态
     */
    Status?: EnumCompanyFollowUpRecordStatus;
}

/**
 * 跟进记录详细-表单校验
 */
export const DtoDetailCompanyFollowUpRecordRules = {
}

/**
 * 跟进记录详细-设置项
 */
export const DtoDetailCompanyFollowUpRecordMiezzDetailItems: MiezzFormItem[] = [
  {
    Prop: "Code",
    Label: "计划编号",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "CustomerLabel",
    Label: "客户企业",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "Methods",
    Label: "跟进方式",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "FollowUpPersonLabel",
    Label: "跟进人",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "PlanFollowUpTime",
    Label: "计划跟进时间",
    Type: EnumMiezzFormItemType.Text,
    Pipe: EnumPipe.Time,
  },
  {
    Prop: "PlanCompleteTime",
    Label: "计划完成时间",
    Type: EnumMiezzFormItemType.Text,
    Pipe: EnumPipe.Time,
  },
  {
    Prop: "AreaLabel",
    Label: "地点",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "Address",
    Label: "详细地址",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "CustomerJoinPerson",
    Label: "对方参与人员",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "InnerAccompanyPeople",
    Label: "内部陪同人员",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "OuterAccompanyPerson",
    Label: "外部陪同人",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "ThreeJoinPerson",
    Label: "第三方参与人员",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "Contents",
    Label: "跟进内容",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "Description",
    Label: "跟进内容描述",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "Files",
    Label: "附件",
    Customize: true,
  },
  {
    Prop: "Link",
    Label: "超链接",
    Customize: true,
  },
  {
    Prop: "Status",
    Label: "状态",
    Type: EnumMiezzFormItemType.Text,
    Pipe: EnumPipe.Enum,
    Options: EnumCompanyFollowUpRecordStatusOption,
  },
]
